import { resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, normalizeClass as _normalizeClass, withCtx as _withCtx, createCommentVNode as _createCommentVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-18caf7c5"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "main-container" }
const _hoisted_2 = { class: "content-container" }
const _hoisted_3 = { class: "calender" }
const _hoisted_4 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h2", { class: "display-2 textcenter mb-4" }, "Kalender", -1))
const _hoisted_5 = { class: "layout gutter--lg" }
const _hoisted_6 = { class: "row justify--center align--center" }
const _hoisted_7 = { class: "display-6 mb-2 textcenter" }
const _hoisted_8 = { class: "row justify--center boxshadow textcenter" }
const _hoisted_9 = { class: "flex md12 size" }
const _hoisted_10 = { key: 0 }
const _hoisted_11 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("strong", null, "Sidste tilmelding:", -1))
const _hoisted_12 = /*#__PURE__*/_createTextVNode()
const _hoisted_13 = { class: "capitalizedate" }
const _hoisted_14 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("strong", null, "Start:", -1))
const _hoisted_15 = /*#__PURE__*/_createTextVNode()
const _hoisted_16 = { class: "capitalizedate" }
const _hoisted_17 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("strong", null, "Slut:", -1))
const _hoisted_18 = /*#__PURE__*/_createTextVNode()
const _hoisted_19 = { class: "capitalizedate" }
const _hoisted_20 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("strong", null, "Sted:", -1))
const _hoisted_21 = /*#__PURE__*/_createTextVNode()
const _hoisted_22 = { class: "capitalizedate" }
const _hoisted_23 = { key: 1 }
const _hoisted_24 = /*#__PURE__*/_createTextVNode("Yderligere information")
const _hoisted_25 = { key: 2 }
const _hoisted_26 = /*#__PURE__*/_createTextVNode("Yderligere information")
const _hoisted_27 = /*#__PURE__*/_createTextVNode("Luk")
const _hoisted_28 = { class: "center display-4 mb-4 mt-4" }
const _hoisted_29 = { class: "va-table-responsive tableContainer" }
const _hoisted_30 = { class: "va-table va-table--striped tableItem" }
const _hoisted_31 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("thead", null, [
  /*#__PURE__*/_createElementVNode("tr", null, [
    /*#__PURE__*/_createElementVNode("th", null, "Start"),
    /*#__PURE__*/_createElementVNode("th", null, "Begivenhed")
  ])
], -1))
const _hoisted_32 = { class: "sidebar-container" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_LeftSideBar = _resolveComponent("LeftSideBar")!
  const _component_va_chip = _resolveComponent("va-chip")!
  const _component_FullCalendar = _resolveComponent("FullCalendar")!
  const _component_router_link = _resolveComponent("router-link")!
  const _component_va_button = _resolveComponent("va-button")!
  const _component_va_modal = _resolveComponent("va-modal")!
  const _component_vue3_html2pdf = _resolveComponent("vue3-html2pdf")!
  const _component_front_sidebar = _resolveComponent("front-sidebar")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode(_component_LeftSideBar),
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _hoisted_4,
        _createElementVNode("div", _hoisted_5, [
          _createElementVNode("div", _hoisted_6, [
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.includedInCalendar, (item, index) => {
              return (_openBlock(), _createElementBlock("div", {
                class: "flex",
                key: index
              }, [
                _createVNode(_component_va_chip, {
                  color: item.color,
                  class: _normalizeClass(["hoverEffect", { notActive: !item.include}]),
                  onClick: ($event: any) => (_ctx.changeCalendarView(index))
                }, {
                  default: _withCtx(() => [
                    _createTextVNode(_toDisplayString(item.name), 1)
                  ]),
                  _: 2
                }, 1032, ["color", "class", "onClick"])
              ]))
            }), 128))
          ])
        ]),
        _createVNode(_component_FullCalendar, {
          ref: "fullCalender",
          options: _ctx.calendarOptions
        }, null, 8, ["options"]),
        _createVNode(_component_va_modal, {
          modelValue: _ctx.calendarModal,
          "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.calendarModal) = $event)),
          "overlay-opacity": "0.5",
          size: "large",
          "hide-default-actions": ""
        }, {
          footer: _withCtx(() => [
            _createVNode(_component_va_button, {
              class: "btn",
              color: "success",
              onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.calendarModal = false))
            }, {
              default: _withCtx(() => [
                _hoisted_27
              ]),
              _: 1
            })
          ]),
          default: _withCtx(() => [
            _createElementVNode("h6", _hoisted_7, _toDisplayString(_ctx.calendarDataType.title), 1),
            _createElementVNode("div", _hoisted_8, [
              _createElementVNode("div", _hoisted_9, [
                (_ctx.calendarDataType.lastRegistrationDate !== '')
                  ? (_openBlock(), _createElementBlock("p", _hoisted_10, [
                      _hoisted_11,
                      _hoisted_12,
                      _createElementVNode("span", _hoisted_13, _toDisplayString((new Date(_ctx.calendarDataType.lastRegistrationDate).toLocaleDateString('da-DK', {weekday: 'long', day: 'numeric', month: 'long', year: 'numeric'}))), 1)
                    ]))
                  : _createCommentVNode("", true),
                _createElementVNode("p", null, [
                  _hoisted_14,
                  _hoisted_15,
                  _createElementVNode("span", _hoisted_16, _toDisplayString(_ctx.capitalizeFirstLetter(_ctx.danishDataWClock2(_ctx.calendarDataType.start))), 1)
                ]),
                _createElementVNode("p", null, [
                  _hoisted_17,
                  _hoisted_18,
                  _createElementVNode("span", _hoisted_19, _toDisplayString((new Date(_ctx.calendarDataType.end).toLocaleDateString('da-DK', {weekday: 'long', day: 'numeric', month: 'long', year: 'numeric'}))), 1)
                ]),
                _createElementVNode("p", null, [
                  _hoisted_20,
                  _hoisted_21,
                  _createElementVNode("span", _hoisted_22, _toDisplayString(_ctx.convertHTMLToText(_ctx.calendarDataType.place)), 1)
                ]),
                (_ctx.calendarType === 'competition' && _ctx.calendarDataType.status)
                  ? (_openBlock(), _createElementBlock("div", _hoisted_23, [
                      _createVNode(_component_router_link, {
                        to: { name: 'Competition', params: { slug: _ctx.constructSlug(_ctx.calendarDataType.id, _ctx.calendarDataType.title, _ctx.calendarDataType.start)}}
                      }, {
                        default: _withCtx(() => [
                          _hoisted_24
                        ]),
                        _: 1
                      }, 8, ["to"])
                    ]))
                  : _createCommentVNode("", true),
                (_ctx.calendarType === 'event' && _ctx.calendarDataType.status)
                  ? (_openBlock(), _createElementBlock("div", _hoisted_25, [
                      _createVNode(_component_router_link, {
                        to: { name: 'Event', params: { slug: _ctx.constructSlug(_ctx.calendarDataType.id, _ctx.calendarDataType.title, _ctx.calendarDataType.start)}}
                      }, {
                        default: _withCtx(() => [
                          _hoisted_26
                        ]),
                        _: 1
                      }, 8, ["to"])
                    ]))
                  : _createCommentVNode("", true)
              ])
            ])
          ]),
          _: 1
        }, 8, ["modelValue"]),
        _createVNode(_component_vue3_html2pdf, {
          "show-layout": false,
          "float-layout": true,
          "preview-modal": true,
          "enable-download": false,
          "paginate-elements-by-height": 1400,
          filename: 'dart-begivenheder-' + _ctx.pdfTitle,
          "pdf-quality": 2,
          "manual-pagination": false,
          "pdf-format": "a4",
          "pdf-orientation": "portrait",
          "pdf-content-width": "100%",
          ref: "html2Pdf"
        }, {
          "pdf-content": _withCtx(() => [
            _createElementVNode("h4", _hoisted_28, _toDisplayString('Dart begivenheder i ' + _ctx.pdfTitle), 1),
            _createElementVNode("div", _hoisted_29, [
              _createElementVNode("table", _hoisted_30, [
                _hoisted_31,
                _createElementVNode("tbody", null, [
                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.eventForCalendar, (item, index) => {
                    return (_openBlock(), _createElementBlock("tr", { key: index }, [
                      _createElementVNode("td", null, _toDisplayString(item.start), 1),
                      _createElementVNode("td", null, _toDisplayString(item.title), 1)
                    ]))
                  }), 128))
                ])
              ])
            ])
          ]),
          _: 1
        }, 8, ["filename"])
      ])
    ]),
    _createElementVNode("div", _hoisted_32, [
      _createVNode(_component_front_sidebar)
    ])
  ]))
}